import { render } from "./StackField.vue?vue&type=template&id=48cafd82"
import script from "./StackField.vue?vue&type=script&lang=js"
export * from "./StackField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"StackField.vue"]])

export default __exports__